import { StyledIcon } from '../Icon.Styled'
import type { IconProps } from '../Icon.Types'

export const SfArrowLeftIcon = (props: IconProps) => {
  return (
    <StyledIcon
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.4707 18.5449C10.1895 18.5449 9.93457 18.4307 9.70605 18.2021L3.94043 12.4453C3.70605 12.2227 3.58887 11.9531 3.58887 11.6367C3.58887 11.3203 3.70605 11.0508 3.94043 10.8281L9.68848 5.08008C9.81152 4.95703 9.9375 4.86914 10.0664 4.81641C10.2012 4.75781 10.3359 4.72852 10.4707 4.72852C10.793 4.72852 11.0537 4.82812 11.2529 5.02734C11.4521 5.22656 11.5518 5.47266 11.5518 5.76562C11.5518 5.92383 11.5195 6.07031 11.4551 6.20508C11.3965 6.33398 11.3174 6.44824 11.2178 6.54785L9.24902 8.53418L5.88281 11.6367L9.24902 14.7393L11.2178 16.7256C11.3174 16.8252 11.3965 16.9395 11.4551 17.0684C11.5195 17.1973 11.5518 17.3438 11.5518 17.5078C11.5518 17.8008 11.4521 18.0469 11.2529 18.2461C11.0537 18.4453 10.793 18.5449 10.4707 18.5449ZM8.92383 12.7354L5.72461 12.5508C5.44336 12.5508 5.21484 12.4658 5.03906 12.2959C4.86914 12.126 4.78418 11.9062 4.78418 11.6367C4.78418 11.3672 4.86914 11.1475 5.03906 10.9775C5.21484 10.8076 5.44336 10.7227 5.72461 10.7227L8.92383 10.5469H19.2949C19.6289 10.5469 19.8984 10.6494 20.1035 10.8545C20.3086 11.0537 20.4111 11.3145 20.4111 11.6367C20.4111 11.9648 20.3086 12.2314 20.1035 12.4365C19.8984 12.6357 19.6289 12.7354 19.2949 12.7354H8.92383Z"
        fill="currentColor"
      />
    </StyledIcon>
  )
}
